<script>
import {dom, Platform, useQuasar} from "quasar"
import {computed, inject, onMounted, ref, watch, defineProps, nextTick,toRef} from "vue";
import {useStore} from "vuex";
import {getRandomString ,generateShortId, isEmpty} from '@/tools/utils';
import {tableColResize} from '@/tools/table-drag';
import {isNotEmpty} from '@/tools/utils';
export default {
  name: 'piece-base-table',
  props: ['tableTitle','tableSet','tableHeight'],
  setup(props, context) {
    const store = useStore()
    const $q = useQuasar();
    let tableSource =  toRef(props,'tableSet');
    let tableHeightValue = toRef(props,'tableHeight');
    let data = ref([]);
    let tableKey = ref(getRandomString(6));
    let selected = ref([]);
    let dense = ref(true);
    let loading = ref(false);
    let table_height = ref('100%');
    let data_q_table = ref();
    let pagination = ref({
      rowsPerPage:0,
      page: tableSource.value.pagination ? parseInt(tableSource.value.pagination.page) : 1,
    });
    let showColumns = computed(() => {
      return tableSource.value.columns.filter(it => {
        return it.required;
      })
    })
    let showTableColumns  =computed(()=>{
      return tableSource.value.columns.filter(it => {
        return it.check;
      })
    })
    const tableStyle = computed(() => {
      if (!tableSource.value.isFullscreen) {
        let dic = {};
        if(isNotEmpty(tableHeightValue.value)){
          dic['height'] =  tableHeightValue.value;
        }else if (tableSource.value.height && tableSource.value.height.length) {
          dic['height'] =  tableSource.value.height;
        }
        if (tableSource.value.maxHeight && tableSource.value.maxHeight.length) {
          dic['max-height'] = tableSource.value.maxHeight;
        }
        return dic;
      }else{
        return {
          height:'100%'
        }
      }
    });
    watch(()=>tableSource.value,(v)=>{
      if (v.data != data.value) { //防止递归更新
        data.value = JSON.parse(JSON.stringify(v.data));
      }
    },{
      deep: true
    })
    watch(()=>data.value,(v)=>{
      if (tableSource.value.updated) {
        let loc = tableSource.value.updated[0] + '/' + tableSource.value.updated[1];
        store.dispatch(loc, {data: v});
      }
    },{
      deep: true
    })
    watch(()=>selected.value,(v)=>{
      if (tableSource.value.updated) {
        let loc = tableSource.value.updated[0] + '/' + tableSource.value.updated[1];
        store.dispatch(loc, {selected: v});
      }
      if (tableSource.value.selected_change) {
        let loc = tableSource.value.selected_change[0] + '/' + tableSource.value.selected_change[1];
        store.dispatch(loc, v);
      }
    },{
      deep: true
    })
    function myczlClick({type,row}){
      context.emit('myczlClick',{type,row})
    }
    function isValueEmpty(value){
      return isEmpty(value)
    }
    function toggleFullscreen(prop){
      tableSource.value.isFullscreen = !tableSource.value.isFullscreen;
      prop.toggleFullscreen();
    }
    function cellClick(props){
      if(props.col.click){
        context.emit('cellClick',props);
      }
    }
    function init_table(){
      let tb = tableSource.value;
      tb.visibleColumns = [];
      tb.columns.forEach(it => {
        if ($q.platform.is.mobile) {
          it.check = it.required ? true : false;
        }
        if (it.check) {
          tb.visibleColumns.push(it.name);
        }
      })
    }
    function set_table_height(){
      if (!Platform.is.mobile) {
        table_height.value = window.innerHeight - dom.offset(data_q_table.value).top - 45 + 'px'
      }
    }
    function onRowDbClick(evt, row, index){
      context.emit("row-dblclick", row);
    }
    function onRowClick(evt, row){
      if (tableSource.value.selection && tableSource.value.selection == 'single') {
        tableSource.value.selected = []
        tableSource.value.selected.push(row);
        updateSelected(tableSource.value.selected )
      }
      if (tableSource.value.selection && tableSource.value.selection == 'multiple') {
        let isHasNowRow = tableSource.value.selected.some(item=>{item[tableSource.value['row_key']] == row['row_key']})
        if(isHasNowRow){
          tableSource.value.selected = tableSource.value.selected.filter(item=>{
            item[tableSource.value['row_key']] != row['row_key'];
          })
        }else{
          tableSource.value.selected.push(row)
        }
      }
    }
    function tool_update(value,item) {
      context.emit("tool_update", {sign:item.sign,value:value});
    }
    function tool_click(item) {
      context.emit("tool_click", item.sign);
    }
    let source_pages = computed(() => {
      let tot = tableSource.value.pagination.count
          ? tableSource.value.pagination.count
          : 0;
      let rowpage = parseInt(tableSource.value.pagination.rowsPerPage);
      let pages = Math.ceil(tot / rowpage) ;
      return pages;
    });
    function selectCol(key){
      tableSource.value.visibleColumns = []
      let cols = tableSource.value.columns
      cols.forEach(it => {
        if (it.name === key) {
          it.check = !it.check
        }
        if (it.check) {
          tableSource.value.visibleColumns.push(it.name)
        }
      })
    }
    function selectionFun(data){
      // tableKey.value = getRandomString(6);

    }
    function upDateEnable(value,prop){
      let params = {
        value,prop
      }
      context.emit('upDateEnable', params);
    }
    function startResize(event,props){
      tableColResize(event,props,tableSource.value.columns);
    }
    function goLink(value){
      window.open(value);
    }
    function changeRowsPage(value){
      context.emit('changeRowsPage',value);
    }
    function changePage(value){
      context.emit('changePage',value);
    }
    function updateSelected(data){
      context.emit('updateSelected',data);
    }
    init_table();
    return {
      goLink,
      data,
      dense,
      loading,
      selected,
      tableStyle,
      cellClick,
      toggleFullscreen,
      showColumns,
      table_height,
      pagination,
      showTableColumns,
      tableSource,
      init_table,
      data_q_table,
      onRowClick,
      set_table_height,
      tool_click,
      selectCol,
      source_pages,
      tableKey,
      selectionFun,
      isValueEmpty,
      onRowDbClick,
      upDateEnable,
      startResize,
      myczlClick,
      tool_update,
      changeRowsPage,
      changePage,
      updateSelected
    }
  }
}
</script>
<template>
  <div ref="data_q_table" class="user-table">
    <q-table
        :key="tableKey"
        separator="cell"
        :dense="dense"
        square flat color="primary"
        :rows="tableSource.data"
        :row-key="tableSource.row_key"
        :columns="showTableColumns"
        :pagination="{rowsPerPage:0}"
        :hide-pagination="tableSource.hidePagination"
        virtual-scroll
        :loading="tableSource.loading"
        :visible-columns="tableSource.visibleColumns"
        :selection="tableSource.selection"
        v-model:selected="tableSource.selected" hide-selected-banner
        @update:selected="updateSelected"
        @selection="selectionFun"
        @row-click="onRowClick"
        @row-dblclick="onRowDbClick"
        @resize="set_table_height"
        :style="tableStyle"
        no-data-label="无可用数据"
        :class="{[tableSource.table_class]:!isValueEmpty(tableSource.table_class),'base-table':isValueEmpty(tableSource.table_class),myczl:!isValueEmpty(tableSource.actionListCode)}"

        class="table-border my-sticky-header-table"
    >
      <!-- 标题栏右侧图标 -->
      <template v-slot:header-cell="props">
        <q-th :props="props" :style="props.col.style ? props.col.style : ''">
          {{ props.col.label}}
          <!-- fa fa-info-circle -->
          <q-icon :class="props.col.icon" style="font-size:16px; color:gray;" v-if="props.col.icon">
            <q-tooltip anchor="top middle" self="bottom middle" v-if="props.col.icontip">
              <div v-for="(tip, index) in tipToArr(props.col.icontip)" :key="index">
                {{ tip }}
                <br v-if="index < props.col.icontip.length - 1">
              </div>
            </q-tooltip>
          </q-icon>
          <div class="my-table-resizer" @click.stop @mousedown.prevent="(evnt)=>startResize(evnt,props)"></div>
        </q-th>
      </template>
      <template v-slot:body-cell-table__index="props">
        <q-td :props="props">
          {{ props.rowIndex + 1 }}
        </q-td>
      </template>
      <template v-slot:body-cell="props">
        <q-td :props="props" v-if="props.col.edit" class="bg-light-blue-3" :class="props.col.class ? props.col.class : ''">
          {{isValueEmpty(props.value) || props.value == 'null' ? '':props.value }}
          <q-popup-edit v-model="props.row[props.col.name]" :title="'修改第'+(props.rowIndex+1)+'行：'+props.col.label"
                        buttons
                        v-if="props.col.edit" v-slot="scope">
            <q-input :type="props.col.edit" v-model="scope.value" dense autofocus outlined filled/>
          </q-popup-edit>
        </q-td>
        <q-td :props="props" v-else @click="cellClick(props)" :class="props.col.class ? props.col.class : ''">
          <template v-if="props.col.name=='link'">
            <div>
              <q-icon name="fas fa-link" color="primary" class="serch-icon" @click="goLink(props.value)"></q-icon>
            </div>
          </template>
          <template v-else-if="props.col.name=='FMaterialImg'">
            <div>
              <img style="height: 20px;width: 20px" :src="props.value"/>
              <q-tooltip class="bg-white my-tooltip-border" style="border: 1px solid">
                <img style="width:200px" :src="props.value"/>
              </q-tooltip>
            </div>
          </template>
          <template v-else-if="props.col.name=='myczl'">
            <template v-if="tableSource.actionListCode =='orderGoodsCKD'">
              <div>
                <q-btn class="my-text-btn" flat dense size="xl" label="出库详情" @click="myczlClick({type:'outboundEntry',row:props.row})"></q-btn>
              </div>
            </template>

            <template v-if="tableSource.actionListCode =='orderGoodsZXD'">
              <div>
                <q-btn class="my-text-btn" flat dense size="xl" label="装箱详情" @click="myczlClick({type:'pickingEntry',row:props.row})"></q-btn>
              </div>
              <div>
                <q-btn class="my-text-btn" flat dense size="xl" label="装箱视频" @click="myczlClick({type:'pickingVideo',row:props.row})"></q-btn>
              </div>
              <div>
                <q-btn class="my-text-btn" flat dense size="xl" label="物流轨迹" @click="myczlClick({type:'logisticsTrajectory',row:props.row})"></q-btn>
              </div>
            </template>
          </template>
          <!--性别-->
          <template v-else-if="props.col.name=='FSex'">
            {{isValueEmpty(props.value) || props.value == 'null' || props.value == 'undefined'? '': (props.value == '1' ? '男' : '女') }}
          </template>
          <!--ERP销售订单状态-->
          <template v-else-if="props.col.name=='FERPOderStatus'">
            <span v-if="isValueEmpty(props.value) || props.value == 'null' || props.value == 'undefined'"></span>
            <span v-else>
              <span v-if="props.value == 'true'" class="text-positive">
                <q-icon name="fas fa-check-circle" size="xs" /> 成功
              </span>
              <span v-else class="text-negative">
                <q-icon name="fas fa-times-circle" size="xs" /> 失败
                <q-tooltip anchor="top middle" self="bottom middle">点击查看日志</q-tooltip>
              </span>
            </span>
          </template>
          <!--询价单页面 询价单状态-->
          <template v-else-if="props.col.name=='FQuotationStatus' && props.col.label == '询价单状态'">
            <span v-if="isValueEmpty(props.value) || props.value == 'null' || props.value == 'undefined'"></span>
            <span v-else>
              <span v-if="props.value == '保存'" class="text-negative">
                <q-icon name="fas fa-times-circle" size="xs" /> 未提交
              </span>
              <span v-else-if="props.value == '询价'" class="text-primary">
                <q-icon name="fas fa-check-circle" size="xs" /> 已提交
              </span>
              <span v-else-if="props.value == '报价'" class="text-warning">
                <q-icon name="fas fa-exclamation-circle" size="xs" /> 未确认
              </span>
              <span v-else-if="props.value == '已确认'" class="text-positive">
                <q-icon name="fas fa-check-circle" size="xs" /> 已确认
              </span>
            </span>
          </template>
          <!--报价单页面 是否报价-->
          <template v-else-if="props.col.name=='FQuotationStatus' && props.col.label == '报价单状态'">
            <span v-if="isValueEmpty(props.value) || props.value == 'null' || props.value == 'undefined'"></span>
            <span v-else>
               <span v-if="props.value == '报价'" class="text-primary">
                <q-icon name="fas fa-check-circle" size="xs" /> 已报价
              </span>
              <span v-else-if="props.value == '询价'" class="text-warning">
                <q-icon name="fas fa-exclamation-circle" size="xs" /> 未报价
              </span>
               <span v-else class="text-positive">
                <q-icon name="fas fa-check-circle" size="xs" /> 已确认
              </span>
            </span>
          </template>
          <!--确认单页面 客户是否确认-->
          <template v-else-if="props.col.name=='FQuotationStatus' && props.col.label == '客户是否确认'">
            <span v-if="isValueEmpty(props.value) || props.value == 'null' || props.value == 'undefined'"></span>
            <span v-else>
              <span v-if="props.value == '确认'" class="text-positive">
                <q-icon name="fas fa-check-circle" size="xs" /> 是
              </span>
              <span v-else class="text-warning">
                <q-icon name="fas fa-exclamation-circle" size="xs" /> 否
              </span>
            </span>
          </template>
          <template v-else-if="props.col.name == 'serialCol'">
            {{props.rowIndex+1}}
          </template>
          <template v-else-if="props.col.name == 'FEnable'">
            <q-toggle color="primary" size='xs' :false-value="false" :true-value="true" v-model="tableSource.data[props.rowIndex][props.col.name]" @update:model-value="(value)=>upDateEnable(value,props)">
            </q-toggle>
          </template>
          <template v-else>
            <span>
              {{isValueEmpty(props.value) || props.value == 'null' || props.value == 'undefined'? '':props.value }}
              <q-tooltip anchor="top middle" self="bottom middle" v-if="!(isValueEmpty(props.value) || props.value == 'null' || props.value == 'undefined')">{{props.value}}</q-tooltip>
            </span>
          </template>
        </q-td>
      </template>

      <template v-slot:top="props" v-if="tableTitle">
        <q-toolbar class="bg-grey-2">
          <span class="q-ml-sm">{{ tableTitle ? tableTitle : '' }}</span>
          <q-space/>
          <div class="q-gutter-sm text-right">
            <q-btn v-for="item in tableSource.tools.buttons" :key="item.index" rounded flat dense size="md"
                   :icon="item.icon" color="primary" @click="tool_click(item)">
              <q-tooltip anchor="top middle" self="bottom middle">{{ item.label }}</q-tooltip>
            </q-btn>
            <q-btn rounded flat dense size="md" icon="fas fa-columns" color="primary">
              <q-tooltip anchor="top middle" self="bottom middle">设置显示列</q-tooltip>
              <q-menu :offset="[0, 12]">
                <q-list dense>
                  <q-item clickable v-for="(column, index) in showColumns" :key="index" :active="column.check"
                          @click="selectCol(column.name)">
                    <q-item-section>{{ column.label }}</q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
            <q-btn rounded flat dense size="md" icon="fas fa-table" color="primary" @click="dense=!dense">
              <q-tooltip anchor="top middle" self="bottom middle">密集表格</q-tooltip>
            </q-btn>
            <q-btn rounded color="primary" flat round dense
                   :icon="props.inFullscreen ? 'fas fa-compress' : 'fas fa-expand'"
                   @click="props.toggleFullscreen">
              <q-tooltip anchor="top middle" self="bottom middle">全屏</q-tooltip>
            </q-btn>
          </div>
        </q-toolbar>
      </template>
      <template v-slot:top="props" v-else-if="tableSource?.tools?.isShow">
        <q-toolbar class="bg-grey-2">
          <span class="q-ml-sm">{{ tableTitle ? tableTitle : '' }}</span>
          <q-space/>
          <div class="q-gutter-sm text-right">
            <template v-if="!isValueEmpty(tableSource.tools.checkBoxs)">
              <q-checkbox class="my-checkbox" @update:model-value="(val)=>tool_update(val,item)" v-for="(item,index) in tableSource.tools.checkBoxs" :key="index" v-model="item.value" size='xs' style="font-szie:12px" :label="item.name" riht-label false-value="0" true-value="1">
              </q-checkbox>
            </template>

            <q-btn class="my-text-btn" v-for="item in tableSource.tools.buttons" :label="item.name" :key="item.index" flat dense size="xl"
                   @click="tool_click(item)">
            </q-btn>
            <q-btn class="my-text-btn" flat dense size="xl" label="设置显示列">
              <q-menu :offset="[0, 12]">
                <q-list dense>
                  <q-item clickable v-for="(column, index) in showColumns" :key="index" :active="column.check"
                          @click="selectCol(column.name)">
                    <q-item-section>{{ column.label }}</q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
            <!--            <q-btn rounded flat dense size="md" icon="fas fa-table" color="primary" @click="dense=!dense">-->
            <!--              <q-tooltip>密集表格</q-tooltip>-->
            <!--            </q-btn>-->
            <q-btn class="my-text-btn" :label=" props.inFullscreen ? '缩小' : '全屏' " flat dense
                   @click="toggleFullscreen(props)">
            </q-btn>
          </div>
        </q-toolbar>
      </template>
      <template v-slot:bottom v-if="tableSource.pagination && !tableSource.hidePagination">
        <div class="inline-block">
          <span class="inline-block text-body2">
            每页行数：
          </span>
          <span class="inline-block">
            <q-select class="table-pages" @update:model-value="changeRowsPage" v-model="tableSource.pagination.rowsPerPage" filled dense options-dense :options="[10,30,50,100]" />
          </span>
        </div>
        <div class="inline-block q-mx-sm items-center">
          <div class="inline-block text-body2">
            数据总行：
          </div>
          <div class="inline-block">
            <q-badge color="primary" align="middle" outline>
              {{
                tableSource.pagination ? (tableSource.pagination.count ? tableSource.pagination.count : tableSource.data.length) : data.length
              }}
            </q-badge>
          </div>
        </div>
        <q-pagination v-model="tableSource.pagination.page" color="primary" @update:model-value="changePage"  :max-pages="6"  :max="source_pages" size="12px"
                      :boundary-numbers="true" :boundary-links="true"
                      class="float-right my-pagination"> </q-pagination>
      </template>
    </q-table>
  </div>
</template>
<style lang="scss" scoped>
body {
  cursor: default;
}
.ew-resize-cursor {
  cursor: ew-resize !important;
}
.table-border{
  ::v-deep td {
    overflow: hidden;
    //word-wrap: break-word !important;
    //white-space: normal;
  }
  ::v-deep .q-table__middle {
    border: 1px solid #e0e0e0 !important;
  }
  ::v-deep .q-table{
    border-bottom:1px solid #e0e0e0;
  }
  ::v-deep .q-table thead tr th{
    background-color: #E2E7EF;
    text-align: center;
  }
  ::v-deep.q-table--dense .q-table__top {
    padding: 6px 0px;
  }
  ::v-deep .q-table--dense .q-table td:first-child {
    padding-left: 16px;
    background-color: white;
  }
  ::v-deep .q-table tbody tr td:first-child{
    background-color: white;
  }
}
::v-deep .q-toolbar {
  min-height: 33px;
}

::v-deep .q-btn .q-icon {
  font-size: 22px !important;
}
.inline-block{
  display: inline-block!important;
}
.my-pagination {
  .q-pagination__middle > .q-btn {
    width: 10px;
    max-width: 10px !important;
  }
}
::v-deep.table-pages .q-field__native{
  min-height: 0px;
}
::v-deep.my-sticky-header-column-table{
  thead tr th{
    position: sticky;
    z-index: 2;
    background: #fff;
  }
}
.my-text-btn:hover{
  color: #42A5F5;
}
.my-tooltip-border{
  border:1px solid #111;
}
::v-deep .my-checkbox .q-checkbox__label{
  font-size: 12px !important;
}
</style>
<style lang="sass">
.my-sticky-header-table
  height: 310px
  thead tr th
    position: sticky
    z-index: 1
  thead tr:first-child th
    top: 0
  &.q-table--loading thead tr:last-child th
    top: 48px
.myczl
  th:last-child,
  td:last-child
    position: sticky
    right: 0
    z-index: 1
    background-color: #F0F0F0
</style>
